import { DecisionMenuItemsIdsEnum } from '../enums/DecisionMenuItemsIdsEnum';

export const KNO_ORGANIZATION_BLOCK_ID = 'knoOrganizationBlock';
export const KIND_CONTROL_BLOCK_ID = 'kindControlBlock';
export const KIND_BLOCK_ID = 'kindBlock';
export const BASIS_DOCUMENT_DATE_TIME_BLOCK_ID = 'basisDocumentDateTimeBlock';
export const BASIS_DOCUMENT_NUMBER_BLOCK_ID = 'basisDocumentNumberBlock';
export const DECISION_RESULT_BLOCK_ID = 'decisionResultBlock';
export const ORGANIZATION_BLOCK_ID = DecisionMenuItemsIdsEnum.KNM_VERIFIED_PERSON;
